import "./TemplateTaskPanelRightReadonly.css";

import { AsteriskButtonIcon, MilestoneFlagIcon, RepeatIcon } from "../../../../assets";
import { ProjectPhase } from "../../../../constants/project-phase";
import { SelectData, TemplateTaskPanelData } from "../../../../models";
import { camelCaseToSentenceCase, sentenceOrPascalToCamel } from "../../../../utils";
import { Column, FormLabel, ReadonlyText, Row } from "../../../../widget";

export interface TemplateTaskPanelRightReadonlyProps {
  currentStepPhase: string | undefined;
  stepSelectData: SelectData;
  shouldHideOrganisationFields: boolean;

  currentTemplateTask: TemplateTaskPanelData;
}

export const TemplateTaskPanelRightReadonly = ({
  currentStepPhase,
  stepSelectData,
  shouldHideOrganisationFields,

  currentTemplateTask,
}: TemplateTaskPanelRightReadonlyProps): JSX.Element => {
  const sentenceCaseDefaultDeadlineField =
    currentTemplateTask?.defaultDeadlineField &&
    camelCaseToSentenceCase(sentenceOrPascalToCamel(currentTemplateTask?.defaultDeadlineField));

  const isOngoingMonitoringPhase = currentStepPhase === ProjectPhase.ongoingMonitoring;
  return (
    <div className="TemplateTaskPanelRightReadonly">
      <div className="TemplateTaskPanelRightReadonlyMainActions">
        <Row spacingV="ml">
          <Column span={12}>
            <FormLabel label="Phase" />
            <ReadonlyText
              value={currentStepPhase !== undefined ? camelCaseToSentenceCase(currentStepPhase) : currentStepPhase}
            />
          </Column>
        </Row>
        {currentTemplateTask?.workflowTemplateStepUuid && (
          <Row spacingV="ml">
            <Column span={12}>
              <FormLabel label="Step" />
              <ReadonlyText
                value={stepSelectData.find((step) => step.key === currentTemplateTask?.workflowTemplateStepUuid)?.value}
              />
            </Column>
          </Row>
        )}
        {sentenceCaseDefaultDeadlineField !== null &&
          currentTemplateTask?.defaultDeadlineField &&
          currentTemplateTask?.defaultDeadlineValue !== null && (
            <Row spacingV="ml">
              <Column span={12}>
                <FormLabel label="Deadline" />
                <ReadonlyText
                  value={`${
                    sentenceCaseDefaultDeadlineField === "Start" || sentenceCaseDefaultDeadlineField === "End"
                      ? `Stage ${currentTemplateTask?.defaultDeadlineField}`
                      : sentenceCaseDefaultDeadlineField
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion, @typescript-eslint/no-non-null-asserted-optional-chain
                  } ${currentTemplateTask?.defaultDeadlineValue <= 0 ? " - " : ` + `}${Math.abs(currentTemplateTask?.defaultDeadlineValue!)}`}
                />
              </Column>
            </Row>
          )}
        {!shouldHideOrganisationFields && currentTemplateTask?.ownerOrganisationType !== undefined && (
          <Row spacingV="ml">
            <Column span={12}>
              <FormLabel label="Owner organisation type" />
              <ReadonlyText value={currentTemplateTask?.ownerOrganisationType} />
            </Column>
          </Row>
        )}
        {!shouldHideOrganisationFields && currentTemplateTask?.defaultVisibility !== undefined && (
          <Row>
            <Column span={12}>
              <FormLabel label="Visibility" />
              <ReadonlyText value={currentTemplateTask?.defaultVisibility?.join(", ")} />
            </Column>
          </Row>
        )}
      </div>
      <div className="TemplateTaskPanelRightReadonlyOtherActions">
        <Row spacingV="ml">
          <Column span={12}>
            <p className="body01">Other actions</p>
          </Column>
        </Row>
        <Row spacingV="ml">
          <Column span={12}>
            <div className="TemplateTaskPanelRightReadonlyOtherActionsItem">
              <FormLabel label="Milestone status:" />
              <MilestoneFlagIcon
                className={`MilestoneFlagGreyIcon ${(currentTemplateTask.defaultIsMilestone ?? false) && "Active"}`}
              />
            </div>
          </Column>
        </Row>
        {/* NOTE - hiding this for now KAN-7325 - https://kanaearth.atlassian.net/browse/KAN-7325 */}
        {/* {currentTemplateTask.defaultIsMilestone && currentTemplateTask?.defaultKeyDate && (
          <Row spacingV="m">
            <Column span={12}>
              <FormLabel label="Update key project date" />
              <ReadonlyText value={currentTemplateTask?.defaultKeyDate} />
            </Column>
          </Row>
        )} */}
        <Row spacingV="ml">
          <Column span={12}>
            <div className="TemplateTaskPanelRightReadonlyOtherActionsItem">
              <FormLabel label="Mandatory status:" />
              <AsteriskButtonIcon
                className={`AsteriskButtonIcon ${(currentTemplateTask.defaultIsMandatory ?? false) && "Active"}`}
              />
            </div>
          </Column>
        </Row>
        {isOngoingMonitoringPhase && (
          <Row spacingV="xs">
            <Column span={12}>
              <div className="TemplateTaskPanelRightReadonlyOtherActionsItem">
                <FormLabel label="Repeat status:" />
                <RepeatIcon className={`RepeatIcon ${(currentTemplateTask.defaultRepeat ?? false) && "Active"}`} />
              </div>
            </Column>
          </Row>
        )}
      </div>
    </div>
  );
};
